import React, { ForwardedRef, forwardRef, InputHTMLAttributes } from 'react'
import { IWithFieldSizeProps, withFieldSize } from '../../../../lib/hoc/WithFieldSize'

export interface IInputProps extends IWithFieldSizeProps, InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef((props: IInputProps, ref: ForwardedRef<HTMLInputElement>) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { classSize, fieldSize, ...inputProps } = props

  return (
    <input
      {...inputProps}
      ref={ref}
      className={`w-full truncate rounded-[6px] border-none px-[12px] text-focus-500 outline-none placeholder:text-aqua-300 focus:text-focus-500 disabled:bg-transparent ${classSize} `}
    />
  )
})

export const BaseInput = withFieldSize(Input)
